export const validatePayrollMappingForm = ({ isDropdownSelected, formValues, values, setFieldError, setFieldTouched, showErrorSnackbar }) => {
  if (!isDropdownSelected) {
    showErrorSnackbar("Please map the Employee Name");
    return false;
  }
  if (!formValues.department) {
    showErrorSnackbar("Please map Department as per the system");
    return false;
  }
  if (!formValues.job) {
    showErrorSnackbar("Please map Job Title as per the system");
    return false;
  }

  const wages = values.wage || [];
  const addAndDeductions = values.addAndDeductions || [];
  const taxes = values.eeAndErTaxes || [];

  let hasPartialRow = false;
  let partialRowMsg = "";

  const checkPartialRow = (arr, prefix, fieldKeys, tableName) => {
    arr.forEach((item, index) => {
      const hasAmount = Number(item.gross || item.amount) !== 0;
      if (hasAmount && fieldKeys.some(key => !item[key])) {
        hasPartialRow = true;
          const missingKeys = fieldKeys.filter(k => !item[k]);
          if (!partialRowMsg) {
            if (missingKeys.includes("coa")) {
              partialRowMsg = `If amount is present, please select COA in ${tableName} table.`;
            } else {
              partialRowMsg = `Please fill the row in ${tableName} table.`;
            }
          }
        fieldKeys.forEach(key => {
          if (!item[key]) {
            setFieldTouched(`${prefix}[${index}].${key}`, true, false);
            setFieldError(`${prefix}[${index}].${key}`, "Required");
          } else {
            setFieldError(`${prefix}[${index}].${key}`, undefined);
          }
        });
      } else {
        fieldKeys.forEach(key => setFieldError(`${prefix}[${index}].${key}`, undefined));
        setFieldError(`${prefix}[${index}].gross`, undefined);
        setFieldError(`${prefix}[${index}].amount`, undefined);
      }
    });
  };

  checkPartialRow(wages, "wage", ["mappedTo", "coa"], "Wages");
  checkPartialRow(addAndDeductions, "addAndDeductions", ["addDeduction", "mappedTo", "coa"], "Additions & Deductions");
  checkPartialRow(taxes, "eeAndErTaxes", ["taxType", "mappedTo", "coa"], "EE & ER Taxes");

  if (hasPartialRow) {
    showErrorSnackbar(partialRowMsg);
    return false;
  }

  let hasAllZeroInTable = false;
  let errorMsg = "";

  const checkAllZero = (arr, prefix, valueKey, mappedKeys, msg) => {
    const populated = arr.map((item, index) => ({ row: item, index })).filter(x => mappedKeys.every(k => x.row[k]));
    if (populated.length > 0) {
      const allZero = populated.every(x => Number(x.row[valueKey]) === 0);
      populated.forEach(x => {
        if (allZero) {
          hasAllZeroInTable = true;
          if (!errorMsg) errorMsg = msg;
          setFieldTouched(`${prefix}[${x.index}].${valueKey}`, true, false);
          setFieldError(`${prefix}[${x.index}].${valueKey}`, "Amount cannot be zero");
        }
      });
    }
    // return populated.reduce((sum, x) => sum + Math.abs(Number(x.row[valueKey] || 0)), 0);
    return populated.reduce((sum, x) => sum + Number(x.row[valueKey] || 0), 0);
  };

  const totalWages = checkAllZero(wages, "wage", "gross", ["mappedTo", "coa"], "At least one row must have an amount in Wages table.");
  const totalAddDed = checkAllZero(addAndDeductions, "addAndDeductions", "amount", ["addDeduction", "mappedTo", "coa"], "At least one row must have an amount in Additions & Deductions table.");
  const totalTaxes = checkAllZero(taxes, "eeAndErTaxes", "amount", ["taxType", "mappedTo", "coa"], "At least one row must have an amount in EE & ER Taxes table.");

  if (hasAllZeroInTable) {
    showErrorSnackbar(errorMsg);
    return false;
  }

  if (totalWages === 0 && totalAddDed === 0 && totalTaxes === 0) {
    showErrorSnackbar("Please update at least one completely filled row with an amount.");
    return false;
  }

  return true;
};